import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  DialogBox,
  DialogBoxHeader,
  DialogBoxBody,
  ButtonTertiary,
  ButtonSecondary,
  ButtonPrimary,
  GlyphClose,
} from '@americanexpress/dls-react';
import { BASE_UI_URL } from '@americanexpress/arcade-core';
import { useReactlytics } from '@americanexpress/reactlytics';
import styles from './styles/SurveyPopUp.scss';

const SurveyPopUp = ({
  setIsSurveyPopUpOpen,
  router,
}) => {
  const intl = useIntl();
  const { track } = useReactlytics();

  const handleClose = (button) => {
    track({
      event: {
        identifier: 'axp-passport-survey',
        element: button === 'x-but' ? 'x-but' : 'later',
        type: 'click',
      },
    });
    setIsSurveyPopUpOpen(false);
  };

  const takeSurvey = () => {
    track({
      event: {
        identifier: 'axp-passport-survey',
        element: 'take',
        type: 'click',
      },
    });
    setIsSurveyPopUpOpen(false);
    router.push(`${BASE_UI_URL}/more/feedback?source=popup`);
  };

  return (
    <div data-testid="surveyPopUp">
      <DialogBox onClose={handleClose} theme={{ div: { maxWidth: '480px' } }} id="survey-dialog-box">
        <DialogBoxHeader
          id="survey-dialog-box-header"
          className="flex-align-center flex-justify-center position-relative arcade-min-touch-size"
          theme={{ display: 'flex!important' }}
        >
          <p role="heading" aria-level="2">{intl.formatMessage({ id: 'survey.popup.title' })}</p>
          <div className="flex flex-justify-end position-absolute arcade-min-touch-size" style={{ top: 0, right: 0 }}>
            <ButtonTertiary
              onClick={() => handleClose('x-but')}
              theme={{
                padding: '0rem',
              }}
              reactlytics={{ disable: true }}
              aria-label="close"
              icon={<GlyphClose />}
            />
          </div>
        </DialogBoxHeader>
        <DialogBoxBody id="survey-dialog-box-body">
          <p>{intl.formatMessage({ id: 'survey.popup.text' })}</p>
          <div className={`flex flex-justify-between margin-3-t ${styles.surveyPopUpButtonContainer}`}>
            <div className={styles.surveyPopUpButton}>
              <ButtonSecondary
                id="survey-dialog-box-later"
                theme={{
                  display: 'block',
                  minWidth: 'unset !important',
                  margin: 'auto',
                  height: '100%',
                  width: '100%',
                }}
                reactlytics={{ disable: true }}
                onClick={handleClose}
              >
                {intl.formatMessage({ id: 'survey.popup.button.later' })}
              </ButtonSecondary>
            </div>
            <div className={styles.surveyPopUpButton}>
              <ButtonPrimary
                id="survey-dialog-box-continue"
                theme={{
                  display: 'block',
                  minWidth: 'unset !important',
                  padding: '0.8125rem 0.875rem',
                  margin: 'auto',
                  width: '100%',
                  whiteSpace: 'unset',
                }}
                reactlytics={{ disable: true }}
                onClick={takeSurvey}
              >
                {intl.formatMessage({ id: 'survey.popup.button.survey' })}
              </ButtonPrimary>
            </div>
          </div>
        </DialogBoxBody>
      </DialogBox>
    </div>
  );
};

SurveyPopUp.propTypes = {
  setIsSurveyPopUpOpen: PropTypes.func.isRequired,
  router: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default SurveyPopUp;
